function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgAlret(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 30,
    height: 30,
    viewBox: "0 0 30 30",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    "data-name": "\\uADF8\\uB8F9 5290"
  }, /*#__PURE__*/React.createElement("path", {
    "data-name": "\\uC0AC\\uAC01\\uD615 154443",
    style: {
      fill: "none"
    },
    d: "M0 0h30v30H0z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M111.195-841.769h1.919v-7.357h-1.919zm.96-9.546a1 1 0 0 0 .736-.3 1 1 0 0 0 .3-.736 1 1 0 0 0-.3-.736 1 1 0 0 0-.736-.3 1 1 0 0 0-.736.3 1 1 0 0 0-.3.736 1 1 0 0 0 .3.736 1 1 0 0 0 .735.3zm0 15.623a11.842 11.842 0 0 1-4.741-.957 12.276 12.276 0 0 1-3.86-2.6 12.274 12.274 0 0 1-2.6-3.858 11.829 11.829 0 0 1-.957-4.739 11.841 11.841 0 0 1 .957-4.741 12.277 12.277 0 0 1 2.6-3.86 12.275 12.275 0 0 1 3.858-2.6 11.83 11.83 0 0 1 4.739-.957 11.84 11.84 0 0 1 4.741.957 12.274 12.274 0 0 1 3.86 2.6 12.275 12.275 0 0 1 2.6 3.858 11.83 11.83 0 0 1 .957 4.739 11.84 11.84 0 0 1-.957 4.74 12.276 12.276 0 0 1-2.6 3.86 12.275 12.275 0 0 1-3.858 2.6 11.83 11.83 0 0 1-4.737.959zm0-1.919a9.878 9.878 0 0 0 7.261-2.975 9.878 9.878 0 0 0 2.975-7.261 9.878 9.878 0 0 0-2.975-7.261 9.878 9.878 0 0 0-7.261-2.975 9.878 9.878 0 0 0-7.261 2.975 9.878 9.878 0 0 0-2.975 7.261 9.878 9.878 0 0 0 2.975 7.261 9.878 9.878 0 0 0 7.261 2.975zm-.001-10.235z",
    transform: "translate(-97.154 863)",
    style: {
      fill: "#1cb691"
    }
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAlret);
export default __webpack_public_path__ + "static/media/alret.2d35ec4e65fd06c8907598349dd9a4a9.svg";
export { ForwardRef as ReactComponent };